/**
 * FormInput Component
 * 재사용 가능한 폼 입력 필드
 */
import React from "react";

interface FormInputProps {
    id: string;
    name: string;
    type?: 'text' | 'email' | 'tel';
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    error?: string;
    label?: string;
    showLabel?: boolean;
    icon?: React.ReactNode;
    autoComplete?: string;
}

const FormInput: React.FC<FormInputProps> = ({
    id,
    name,
    type = 'text',
    value,
    onChange,
    onKeyPress,
    placeholder,
    required = false,
    disabled = false,
    className = '',
    error,
    label,
    showLabel = true,
    icon,
    autoComplete = 'off',
}) => {
    return (
        <div className={`form-group ${className}`}>
            {showLabel && label && (
                <label htmlFor={id} className="form-label">
                    {label} {required && <span style={{ color: '#EF4444'}}>*</span>}
                </label>
            )}
            <div className="input-wrapper">
                {icon && <span className="input-icon">{icon}</span>}
                <input
                    type={type}
                    id={id}
                    name={name}
                    className="form-input"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    required={required}
                    disabled={disabled}
                    autoComplete={autoComplete}
                />
            </div>
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default FormInput;
